import { httpRequest } from "@services/http";
import type { RoleDetail } from "./cmdGetRole";

export class CommandSetRolePermissions {
  async run(roleId: number, permissions: { feature_id: number; level: number }[]): Promise<RoleDetail> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/roles/${roleId}/permissions`;
    try {
      return await httpRequest<RoleDetail>(url, { method: "PUT", body: { permissions } });
    } catch (error) {
      console.error("Error setting role permissions:", error);
      throw error;
    }
  }
}
